module.exports = __webpack_public_path__ + "img/drone_05_H.b54fe8f3.jpg";